import { render, staticRenderFns } from "./sidemenu.vue?vue&type=template&id=53ede8eb&scoped=true"
import script from "./sidemenu.vue?vue&type=script&lang=js"
export * from "./sidemenu.vue?vue&type=script&lang=js"
import style0 from "./sidemenu.vue?vue&type=style&index=0&id=53ede8eb&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ede8eb",
  null
  
)

export default component.exports